<template>
  <v-select outlined hide-details :items="items" :value="value" item-text="name" item-value="id" @input="$emit('input', $event)">
    <template #append>
      <mf-icon icon="keyboard_arrow_down" />
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    value: [String, Number],
  },
  data: () => ({
    items: [
      {
        id: '',
        name: 'Todas',
      },
      {
        id: 'F',
        name: 'Física',
      },
      {
        id: 'J',
        name: 'Jurídica',
      },
    ],
  }),
}
</script>
